<div>
  <div
    *ngIf="showPage"
    (click)="back()"
    class="d-flex gap-1 align-items-center back mb-2"
    style="cursor: pointer"
  >
    <i *ngIf="translate.currentLang == 'ar'" class="fas fa-chevron-right"></i>
    <i *ngIf="translate.currentLang == 'en'" class="fas fa-chevron-left"></i>
    <span>{{ "back-to-tickets" | translate }}</span>
  </div>
  <div
    *ngIf="!showPage"
    (click)="BackPaymentMobile()"
    class="d-flex gap-1 align-items-center back mb-2"
    style="cursor: pointer"
  >
    <i *ngIf="translate.currentLang == 'ar'" class="fas fa-chevron-right"></i>
    <i *ngIf="translate.currentLang == 'en'" class="fas fa-chevron-left"></i>
    <span>{{ "back-to-payment" | translate }}</span>
  </div>
  <app-book-title
    *ngIf="showPage"
    booktitle="ticket-reservation"
    info=""
  ></app-book-title>
  <div class="row mt-4">
    <div *ngIf="showPage" class="col-lg-4 col-md-12 col-12">
      <div *ngIf="!isSport" class="coupon-card padding-5 mb-4">
        <p class="code-label">{{ "Discount Code" | translate }}</p>
        <div class="d-flex gap-1">
          <input
            type="text"
            [ngStyle]="{
              'background-color':
                couponDiscount?.promoCodeApplied == true ? '#F7F7FD' : ''
            }"
            style="border-radius: 4px; border: 1px solid #e8e7e0"
            class="form-control"
            placeholder="MAS123"
            aria-label="name"
            [(ngModel)]="copoun"
          />
          <button
            *ngIf="
              couponDiscount?.promoCodeApplied == false ||
              couponDiscount?.promoCodeApplied == null
            "
            (click)="validateCoupon()"
            class="btn apply-btn"
          >
            {{ "Check" | translate }}
          </button>
          <button
            *ngIf="couponDiscount?.promoCodeApplied == true"
            (click)="cancelCoupon()"
            class="btn cancel-btn"
          >
            {{ "Cancel" | translate }}
          </button>
        </div>
      </div>
      <div *ngIf="isMobile" class="col-12 px-0">
        <app-review-details
          [event]="event"
          [invoice]="invoice"
          (detailsMobileOpened)="showReview($event)"
          [showPage]="showPage"
        ></app-review-details>
      </div>
      <div class="coupon-card">
        <p class="order-summary-label padding-5 pb-0">
          {{ "order-summary" | translate }}
        </p>
        <div class="padding-5 pt-0 pb-0">
          <div class="row">
            <div class="col-7">
              <p class="order-summary-value">
                {{ "ticket-prices" | translate }}
              </p>
            </div>
            <div class="col">
              <p class="order-summary-value text-end">
                <ng-container *ngIf="subTotal !== 0">
                  <span
                    [innerHTML]="
                      subTotal
                        | number : '1.2-2'
                        | customCurrency : 'SAR' : 'symbol' : '#555770' : 26
                    "
                  ></span>
                </ng-container>

                <ng-container *ngIf="subTotal === 0">
                  {{ "free" | translate }}
                </ng-container>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-7">
              <p class="order-summary-value">{{ "VAT" | translate }}</p>
            </div>
            <div class="col">
              <p class="order-summary-value text-end">
                <ng-container *ngIf="vat !== 0">
                  <span
                    [innerHTML]="
                      vat
                        | number : '1.2-2'
                        | customCurrency : 'SAR' : 'symbol' : '#555770' : 26
                    "
                  ></span>
                </ng-container>

                <ng-container *ngIf="vat === 0"> ____ </ng-container>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-7">
              <p class="order-summary-value">{{ "Discount" | translate }}</p>
            </div>
            <div class="col">
              <p class="order-summary-value text-end">
                <ng-container *ngIf="couponDiscount">
                  <span
                    [innerHTML]="
                      couponDiscount?.discountAmount
                        | number : '1.2-2'
                        | customCurrency : 'SAR' : 'symbol' : '#555770' : 26
                    "
                  ></span>
                </ng-container>
                <ng-container *ngIf="!couponDiscount"> ____ </ng-container>
              </p>
            </div>
          </div>
        </div>

        <hr class="dashed" />
        <div class="row padding-5 pt-0">
          <div class="col-7">
            <p class="order-summary-value">{{ "total-price" | translate }}</p>
          </div>
          <div class="col">
            <div
              *ngIf="router.url.includes('sport')"
              class="d-flex gap-1"
              style="justify-content: end"
            >
              <p
                class="order-summary-value text-end font-weight-bold"
                style="color: #f9a127"
                [ngClass]="
                  !invoice?.items?.[0]?.ticket?.needToPay && total > 0 ? 'not-need-to-pay' : ''
                "
              >
                <ng-container *ngIf="total !== 0">
                  <span
                    [innerHTML]="
                      total
                        | number : '1.2-2'
                        | customCurrency : 'SAR' : 'symbol' : '#f9a127' : 26
                    "
                  ></span>
                </ng-container>

                <ng-container *ngIf="total === 0">
                  {{ "free" | translate }}
                </ng-container>
              </p>
              <p
                *ngIf="!invoice?.items?.[0]?.ticket?.needToPay && total > 0"
                class="order-summary-value text-end font-weight-bold"
                style="color: red"
              >
                {{ "free" | translate }}
              </p>
            </div>
            <p
              *ngIf="!router.url.includes('sport')"
              class="order-summary-value text-end font-weight-bold"
              style="color: #f9a127"
            >
              <ng-container *ngIf="total !== 0">
                <span
                  [innerHTML]="
                    total
                      | number : '1.2-2'
                      | customCurrency : 'SAR' : 'symbol' : '#f9a127' : 26
                  "
                ></span>
              </ng-container>

              <ng-container *ngIf="total === 0">
                {{ "free" | translate }}
              </ng-container>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="showPage" class="col-lg-1"></div>
    <div *ngIf="!isMobile" class="col-lg-7 col-md-12 col-12 margin-container">
      <app-review-details
        [event]="event"
        [invoice]="invoice"
        (detailsMobileOpened)="showReview($event)"
        [showPage]="showPage"
      ></app-review-details>
    </div>
    <div
      *ngIf="isMobile && !showPage"
      class="col-lg-7 col-md-12 col-12 margin-container"
      style="padding-bottom: 100px"
    >
      <app-review-details-mobile
        [event]="event"
        [invoice]="invoice"
      ></app-review-details-mobile>
    </div>
  </div>
</div>
